import React from 'react';

export interface ConfigState {
    
};

const ConfigContext = React.createContext<Record<string, any>>({});
export default ConfigContext;
